import React from "react"
import styled from "styled-components"
import PropTypes from "prop-types"
import { Card, CardBody, CardTitle, Col, Row } from "reactstrap"
import SplitOrOptimization from "./SplitOrOptimization"
import { AvField } from "availity-reactstrap-validation"
import TTCampaignBudget from "./TTCampaignBudget"
import TtCampaignSpecialAdCategories from "./TTCampaignSpecialAdCategories"

const TTCampaignSettings = ({ items, data, onChange, isFormSubmit }) => {

  // const onChangeCampaignName = ({ target }) => {
  //   onChange(prev => ({ ...prev, campaignName: target.value }))
  // }

  return (
    <Card>
      <TTCampaignSettingsStyled>
        <CardTitle className="font-weight-semibold font-size-14 mb-4">Settings</CardTitle>
        <div className="setting_campaign-name mb-4">
          <Row>
            <Col md={6}>
              <label htmlFor="campaign-name" className="form-label">Campaign name</label>
              <AvField
                name="campaign_name"
                type="text"
                className="form-control"
                id="campaign-name"
                placeholder="Campaign name..."
                // onChange={onChangeCampaignName}
                // value={data.campaignName}
              />
            </Col>
          </Row>
        </div>
        <TtCampaignSpecialAdCategories isFormSubmit={isFormSubmit} />
        <SplitOrOptimization onChange={i => onChange(({ ...i }))} value={data} items={items} />
        <TTCampaignBudget onChange={onChange} items={items} data={data} />
      </TTCampaignSettingsStyled>
    </Card>
  )
}


TTCampaignSettings.propTypes = {
  items: PropTypes.arrayOf(PropTypes.string).isRequired,
  data: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  isFormSubmit: PropTypes.bool.isRequired
}

const TTCampaignSettingsStyled = styled(CardBody)`
  .setting_campaign-name {
    input {
      background-color: #f5f5f5;
      transition: .2s;
      border-color: transparent;

      &:hover {
        background-color: #efefef;
      }

      &:focus, &:focus-visible {
        background-color: transparent !important;
        border-color: #ced4da;
      }
    }
  }
`

export default (TTCampaignSettings)
